import { globalErrorHandler } from "@/helpers/globalResponseHandler";
import { api } from "@/lib/fetch/apiSetup";
import { ApiResponse } from "@/types/api/API";
import { AppSettingsResponse } from "@/types/misc/CheckCompatibilityTypes";

export async function getAppSettings(): Promise<
  ApiResponse<AppSettingsResponse>
> {
  try {
    const response = await api<AppSettingsResponse>(`/links`);

    return { status: true, data: response };
  } catch (error) {
    return { status: false, message: globalErrorHandler(error) };
  }
}
